﻿import { ValgStateActionTypes, ValgState, UPDATE_VALG } from './Types';

import { ThunkAction, ThunkDispatch } from 'redux-thunk';
import { VeilederUtlandAppState } from '..';
import { AnyAction } from 'redux';
import { setVisning } from '../Resultat/Actions';
import VerdensdelValg from '../../Utilities/VerdensdelValg';
import LandOgUniversitetModel from '../../../Shared/Scripts/Models/LandOgUniversitetModel';
import { harValgtLandSomGirRekrutteringsstipend } from '../../Utilities/LandMedRekrutteringsstipend';

export function updateValg(newValg: Partial<ValgState>): ValgStateActionTypes {
    return {
        type: UPDATE_VALG,
        payload: newValg,
    };
}

export const updateVisning = (): ThunkAction<void, VeilederUtlandAppState, {}, AnyAction> => {
    return (dispatch: ThunkDispatch<VeilederUtlandAppState, {}, AnyAction>, getState: () => VeilederUtlandAppState): void => {
        const currentState = getState();

        const visBoksB = visB(currentState);
        const visBoksC = visC(currentState);
        const visBoksD = visD(currentState);
        const visBoksE = visE(currentState);
        const visBoksFa = visFa(currentState, visBoksE);
        const visBoksFb = visFb(currentState, visBoksD, visBoksE);
        const visBoksG = visG(visBoksFa);
        const visBoksH = visH(currentState, visBoksG); 
        const visBetPlan = visUtbetalingsplan(currentState);
        dispatch(setVisning({ visBoksB, visBoksC, visBoksD, visBoksE, visBoksFa, visBoksFb, visBoksG, visBoksH, visBetPlan }));
    };
};

const visUtbetalingsplan = (state: VeilederUtlandAppState): boolean => {
    if(state.valg?.visUtbetalingsplan) return true;

    return false;
};

const visB = (state: VeilederUtlandAppState): boolean => {
    if(state.valg.aUtdanning !== null && state.valg.aUtdanning !== undefined) return true;

    return true;
};

const visC = (state: VeilederUtlandAppState): boolean => {
    if(state.valg.bVerdensdel !== undefined 
        && (state.valg.bVerdensdel.value === VerdensdelValg.b2_asia 
            || state.valg.bVerdensdel.value === VerdensdelValg.b3_europa 
            || state.valg.bVerdensdel.value === VerdensdelValg.b1_afrika 
            || state.valg.bVerdensdel.value === VerdensdelValg.b6_sorAmerika            
            || state.valg.bVerdensdel.value === VerdensdelValg.b4_nordMellomAmerika 
            || state.valg.bVerdensdel.value === VerdensdelValg.b5_oseania))
        return true;

    return false;
};

const visD = (state: VeilederUtlandAppState): boolean => {
    if (state.valg.bVerdensdel === undefined) return false;

         
    if (state.valg.bVerdensdel !== undefined && state.valg.cLand !== undefined) return true;
        return false;
};

//boks for å velge godkjent universitet for å få tileggsstipend
const visE = (state: VeilederUtlandAppState): boolean => {
    if (state.valg.dSkolepenger === undefined) return false;

    //fjerner white space fra string for at parsingen skal fungere som forventet.
    //TODO: fjern evt. tegn som ikke er tall fra strengen.
    const skolePenger: number = parseInt(state.valg.dSkolepenger.value.toString().replace(/\s/g, ''));

    if(state.satser === null) return false;

    if (skolePenger <= state.satser.SATS_ST01_SKOLEPENGESTOTTE_UTENFOR_NORDEN_MAKS_PER_AAR) return false;

    if (harValgtLandMedUtvidetStipend(state.valg, state.universiteter!)){ 
        return true;
    }

    return false;
};

//viser utregning, totalt lån og stipend
const visFa = (state: VeilederUtlandAppState, visBoksE: boolean): boolean => {
    if ((state.valg.bVerdensdel?.value === VerdensdelValg.b1_afrika ||
        state.valg.bVerdensdel?.value === VerdensdelValg.b6_sorAmerika ||
        state.valg.bVerdensdel?.value === VerdensdelValg.b2_asia) &&
        state.valg.dSkolepenger !== undefined &&
        state.valg.dSkolepenger.id !== 'IngenSkolePenger'){

            if(visBoksE && state.valg.eUniversitetUtvidetStipend === undefined ||
                state.valg.eUniversitetUtvidetStipend?.toString() === '')
                return false;

            return true;
        }    

    if (state.valg.dSkolepenger !== undefined &&
        state.valg.dSkolepenger.id !== 'IngenSkolePenger' &&
        state.valg.cLand !== undefined &&
        state.valg.cLand.id === 'E')
        return true;

    if (state.valg.dSkolepenger !== undefined) {
        const skolePenger: number = parseInt(state.valg.dSkolepenger.value.toString().replace(/\s/g, ''));

        if(state.satser === null) return false;

        if (skolePenger <= state.satser.SATS_ST01_SKOLEPENGESTOTTE_UTENFOR_NORDEN_MAKS_PER_AAR)
            return true;

        // har valgt skolepengebeløp over maks men har ikke liste med universiteter  
        if (harValgtLandMedRekrutteringsstipend(state.valg) &&
            !visBoksE &&
            skolePenger > (state.satser.SATS_ST01_SKOLEPENGESTOTTE_UTENFOR_NORDEN_MAKS_PER_AAR) &&
            state.valg.dSkolepenger?.id !== 'IngenSkolePenger') {
            return true;
        }
    }

    if (harValgtLandMedRekrutteringsstipend(state.valg) &&
        state.valg.dSkolepenger !== undefined &&
        state.valg.dSkolepenger?.id !== 'IngenSkolePenger' &&
        state.valg.eUniversitetUtvidetStipend !== undefined &&
        state.valg.eUniversitetUtvidetStipend?.toString() !== '')
        return true;

    if (!visBoksE) return false;

    if (state.valg.eUniversitetUtvidetStipend !== undefined &&
        state.valg.eUniversitetUtvidetStipend?.toString() !== '' &&
        state.valg.dSkolepenger?.id !== 'IngenSkolePenger')
        return true;

    return false;
};

//viser utregning, totalt lån og stipend, men som ikke vet om de skal betale skolepenger. 
const visFb = (state: VeilederUtlandAppState, visBoksD: boolean, visBoksE: boolean): boolean => {
    //dette må skje i riktig rekkefølge.

    if (!visBoksD) return false;
  
    //viser boks Fb dersom man har valgt afrika og ikke skolepenger.
    if ((state.valg.bVerdensdel?.value === VerdensdelValg.b1_afrika ||
        state.valg.bVerdensdel?.value === VerdensdelValg.b6_sorAmerika ||
        state.valg.bVerdensdel?.value === VerdensdelValg.b2_asia) &&
        (state.valg.eUniversitetUtvidetStipend === undefined &&
            state.valg.dSkolepenger?.id === 'IngenSkolePenger')){
                if (harValgtLandMedUtvidetStipend(state.valg, state.universiteter!))
                    return false;
                return true;
            }

    // har valgt "Et annet land" og "Vet ikke"
    if (state.valg.cLand !== undefined && state.valg.cLand.id == "E" && state.valg.dSkolepenger !== undefined && state.valg.dSkolepenger?.id === 'IngenSkolePenger') {
        return true;
    }

    if (!visBoksE) return false;

    // har valgt et land med rekrutteringsstipend, men som ikke har universitet med utvidet støtte, og "vet ikke"
    if (harValgtLandMedRekrutteringsstipend(state.valg) &&
        !harValgtLandMedUtvidetStipend(state.valg, state.universiteter!) &&
        state.valg.dSkolepenger !== undefined &&
        state.valg.dSkolepenger?.id === 'IngenSkolePenger')
            return true;

    // dersom vi har valgt et universitet og "Vet ikke" så vet vi at vi skal vise Fb
    if (state.valg.eUniversitetUtvidetStipend !== undefined && state.valg.dSkolepenger?.id === 'IngenSkolePenger')
        return true;

    return false;
}

const visG = (visBoksFa: boolean): boolean => {
    if (visBoksFa)
        return true;

    return false;
};

const visH = (state: VeilederUtlandAppState, visBoksG: boolean): boolean => {
    if(state.valg.gAntallAr == undefined)
        return false;

    if(state.valg.gAntallAr.value > 0 && visBoksG) {
        return true;
    }

    return false;
}

const harValgtLandMedUtvidetStipend = (valg: ValgState, universiteter: LandOgUniversitetModel[]): boolean => {
    if (valg.cLand?.id === "E") {
        return false;
    }

    for (let i = 0; i < universiteter.length; i++) {
        if (universiteter[i].Landkode === valg.cLand?.id && universiteter[i].Universitet !== "") {
            return true;
        }
    }

    return false;
}

// "Rekrutteringsstipend"/ tilleggsstipend spesielt for utveksling. Gir et ekstra stipend for visse land.
const harValgtLandMedRekrutteringsstipend = (valg: ValgState) => {

    if (harValgtLandSomGirRekrutteringsstipend(valg)) {
        return true;
    }
    return false;
}
